import { useState, useEffect } from 'react';
import { datasets as datasetsApi } from '../api/client';

export default function CorrelationSelector({ currentInstrument, currentTimeframe, selectedIds, onAdd, onRemove, onClose }) {
  const [allDatasets, setAllDatasets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    datasetsApi.list().then(res => {
      setAllDatasets(res.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  // Filter: same timeframe, different instrument, not already selected
  const available = allDatasets.filter(ds =>
    ds.timeframe === currentTimeframe &&
    ds.instrument !== currentInstrument &&
    !selectedIds.includes(ds.id) &&
    (search === '' || ds.instrument.toLowerCase().includes(search.toLowerCase()) || ds.name.toLowerCase().includes(search.toLowerCase()))
  );

  const selectedDatasets = allDatasets.filter(ds => selectedIds.includes(ds.id));

  return (
    <div className="corr-selector">
      <div className="corr-selector-header">
        <h4>Correlation Pairs</h4>
        <button className="btn-icon" onClick={onClose}>&times;</button>
      </div>

      {/* Currently selected */}
      {selectedDatasets.length > 0 && (
        <div className="corr-selected">
          {selectedDatasets.map(ds => (
            <div key={ds.id} className="corr-selected-item">
              <span className="corr-pair-name">{ds.instrument}</span>
              <span className="corr-pair-tf">{ds.timeframe}</span>
              <span className="corr-pair-bars">{ds.bar_count} bars</span>
              <button className="btn-icon" onClick={() => onRemove(ds.id)}>&times;</button>
            </div>
          ))}
        </div>
      )}

      {/* Search */}
      <input
        type="text"
        className="corr-search"
        placeholder="Search instruments..."
        value={search}
        onChange={e => setSearch(e.target.value)}
      />

      {/* Available datasets */}
      <div className="corr-list">
        {loading && <div className="corr-loading">Loading datasets...</div>}
        {!loading && available.length === 0 && (
          <div className="corr-empty">
            No other {currentTimeframe} datasets available.
            Upload or download more data from Market Data.
          </div>
        )}
        {available.map(ds => (
          <div key={ds.id} className="corr-list-item" onClick={() => onAdd(ds.id)}>
            <span className="corr-pair-name">{ds.instrument}</span>
            <span className="corr-pair-tf">{ds.timeframe}</span>
            <span className="corr-pair-bars">{ds.bar_count} bars</span>
            <span className="corr-pair-date">
              {new Date(ds.date_start).toLocaleDateString()} - {new Date(ds.date_end).toLocaleDateString()}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
